/**
 * Header JavaScript
 * Mobile menu, search modal, and sticky header functionality
 */

(function() {
  'use strict';

  // ==========================================
  // MOBILE MENU
  // ==========================================

  const MobileMenu = {
    selectors: {
      toggle: '[data-mobile-menu-toggle]',
      close: '[data-mobile-menu-close]',
      menu: '[data-mobile-menu]',
      overlay: '[data-mobile-menu-overlay]'
    },

    init() {
      this.menu = document.querySelector(this.selectors.menu);
      if (!this.menu) return;

      this.bindEvents();
    },

    bindEvents() {
      // Toggle menu
      document.querySelectorAll(this.selectors.toggle).forEach(btn => {
        btn.addEventListener('click', () => this.open());
      });

      // Close menu
      document.querySelectorAll(this.selectors.close).forEach(btn => {
        btn.addEventListener('click', () => this.close());
      });

      // Close on overlay click
      const overlay = document.querySelector(this.selectors.overlay);
      if (overlay) {
        overlay.addEventListener('click', () => this.close());
      }

      // Close on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.menu.classList.contains('active')) {
          this.close();
        }
      });
    },

    open() {
      this.menu.classList.add('active');
      const overlay = document.querySelector(this.selectors.overlay);
      if (overlay) overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    },

    close() {
      this.menu.classList.remove('active');
      const overlay = document.querySelector(this.selectors.overlay);
      if (overlay) overlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  };

  // ==========================================
  // SEARCH MODAL
  // ==========================================

  // ==========================================
  // 🔥 MEGA FIRE AJAX SEARCH DRAWER 🔥
  // ==========================================
  const SearchModal = {
    selectors: {
      toggle: '[data-search-toggle]'
    },

    init() {
      // Connect toggle buttons to open the mega search
      document.querySelectorAll(this.selectors.toggle).forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (window.tpOpenSearch) {
            window.tpOpenSearch();
          }
        });
      });
    }
  };

  // ==========================================
  // STICKY HEADER
  // ==========================================

  const StickyHeader = {
    selectors: {
      header: '[data-header]'
    },

    init() {
      this.header = document.querySelector(this.selectors.header);
      if (!this.header) return;

      this.lastScrollY = 0;
      this.ticking = false;

      this.bindEvents();
    },

    bindEvents() {
      window.addEventListener('scroll', () => {
        this.lastScrollY = window.scrollY;

        if (!this.ticking) {
          window.requestAnimationFrame(() => {
            this.handleScroll();
            this.ticking = false;
          });

          this.ticking = true;
        }
      });
    },

    handleScroll() {
      // Add shadow when scrolled
      if (this.lastScrollY > 10) {
        this.header.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.08)';
      } else {
        this.header.style.boxShadow = 'none';
      }
    }
  };

  // ==========================================
  // INITIALIZE
  // ==========================================

  document.addEventListener('DOMContentLoaded', () => {
    MobileMenu.init();
    SearchModal.init();
    StickyHeader.init();
  });

})();
